module.exports = __webpack_public_path__ + "static/media/image-vi.c6afeac0.png";